<!-- component -->
<!-- This is an example component -->
<!-- <div class="max-w-lg mx-auto"> -->
<div
  class="bg-white hover:shadow-md transition border border-gray-200 rounded-lg mb-5 h-full"
>
  <a [routerLink]="['/', i18nService.language, 'blog', blog.id]">
    <img class="rounded-t-lg" [src]="blog.image_url" [alt]="blog.title" />
  </a>
  <div class="p-5">
    <a [routerLink]="['/', i18nService.language, 'blog', blog.id]">
      <h5
        class="text-gray-900 font-bold text-2xl tracking-tight mb-2"
        [innerText]="blog.title"
      ></h5>
    </a>
    <p
      class="font-normal text-gray-700 mb-6"
      [innerText]="blog.description"
    ></p>
    <a
      class="primary__btn create__link mt-5"
      [routerLink]="['/', i18nService.language, 'blog', blog.id]"
      translate="Read more"
    >
    </a>
  </div>
</div>
<!-- </div> -->
